var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSymbolCannabisesaude(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 619,
    height: 614,
    viewBox: "0 0 619 614",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.634 532.511C265.519 532.511 230.549 523.278 199.765 506.953C182.662 523.278 159.23 532.511 134.368 532.511C122.626 532.511 111.088 530.42 100.367 526.44C109.965 519.043 118.542 510.218 125.587 500.321C133.398 489.455 139.422 477.262 143.455 464.406C104.349 423.799 80.253 368.243 80.253 307.026C80.253 182.498 179.804 81.5401 302.634 81.5401C425.413 81.5401 525.014 182.498 525.014 307.026C525.014 431.553 425.413 532.511 302.634 532.511ZM580.711 565.008C564.375 542.204 553.041 515.574 547.987 487.924L547.834 486.904C583.979 436.348 605.267 374.212 605.267 307.026C605.267 137.503 469.776 0.120453 302.634 0.120453C135.491 0.120453 0 137.503 0 307.026C0 476.497 135.491 613.88 302.634 613.88C360.832 613.88 415.253 597.198 461.404 568.324C487.746 597.3 526.239 613.88 567.336 613.88C585.204 613.88 602.715 610.768 619 604.697C604.45 593.474 591.432 580.006 580.711 565.008Z",
    fill: "#40B67A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.454 221.78H426.944V277.692C426.944 326.309 405.656 370.896 363.181 411.3L340.616 384.364C358.076 358.908 367.571 335.696 369.154 314.729H325.403L325.454 221.78Z",
    fill: "#48C5DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.119 221.78H296.609V277.692C296.609 326.309 275.372 370.896 232.897 411.3L210.332 384.364C227.792 358.908 237.288 335.696 238.819 314.729H195.119V221.78Z",
    fill: "#40B67A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 619,
    height: 614,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSymbolCannabisesaude);
export default __webpack_public_path__ + "static/media/logo-symbol-cannabisesaude.c4c989f4f690170e868957b8ccfc5d16.svg";
export { ForwardRef as ReactComponent };